
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFF",
                        "d": "M14.79 2.666c-.116-.097-.27-.138-.418-.11l-3.706.658L9.72 2.9c-.27-.09-.558.056-.647.324-.089.268.056.557.324.646l1.07.356c.024.008.05.014.075.018v4.15l-2.115-.65c-.18-.056-.37.045-.426.224-.055.18.046.371.226.426l2.315.713v4.279l-4.43-1.245v-1.926c0-.188-.153-.34-.341-.34-.188 0-.34.152-.34.34v1.935l-3.409.535V3.058c0-.282-.229-.51-.511-.51-.282 0-.511.228-.511.51v10.225c0 .149.065.291.179.388.113.097.264.14.411.117l4.235-.665 4.75 1.334c.045.013.091.019.138.019.03 0 .061-.003.092-.008l3.748-.682c.243-.045.42-.256.42-.503V3.058c0-.15-.067-.294-.183-.392zm-.84 5.31l-2.726.475V4.154l2.726-.485v4.307zm-2.726 5.376v-4.21l2.726-.474v4.188l-2.726.496zM3.276 5.718c.167.33 1.703 2.496 2.17 3.151.096.135.251.215.417.215.167 0 .322-.081.418-.217.465-.661 1.995-2.842 2.152-3.144.207-.397.32-.86.32-1.302 0-1.597-1.3-2.897-2.897-2.897-1.597 0-2.897 1.3-2.897 2.897 0 .442.107.878.317 1.296zm2.58-3.172c1.034 0 1.875.841 1.875 1.875 0 .277-.075.58-.204.83-.09.165-.863 1.287-1.667 2.435-.738-1.044-1.574-2.244-1.67-2.43-.138-.273-.208-.554-.208-.835 0-1.034.84-1.875 1.874-1.875zm-.852 1.876c0 .304.163.585.426.738.264.152.589.152.852 0 .264-.153.426-.434.426-.738 0-.305-.162-.586-.426-.738-.263-.152-.588-.152-.852 0-.263.152-.426.433-.426.738z",
                        "transform": "translate(-1167 -135) translate(1029 125) translate(138 10)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  